module.exports = __webpack_public_path__ + "static/media/Radio-Active.93732864.svg";